import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import messages from '../../../../text/messages';
import AddBilling from './addBilling';

import { getWorkerBillings, saveDeliverable, removeDeliverable, saveExpense, removeExpense } from '../../../../reducers/timekeeping';
import Table from '../../../../components/table';
import { dateToFloatingString } from '../../../../utilities/dateTime';
import { getCurrencySymbol } from '../../../../utilities/string';

class BillingList extends React.Component {
    constructor(props) {
        super(props);

        this.removeBilling = this.removeBilling.bind(this);
        this.saveBilling = this.saveBilling.bind(this);
        this.getColumnDefinition = this.getColumnDefinition.bind(this);
        this.expenseProject = this.expenseProject.bind(this);
    }

    saveBilling(values) {
        const { timesheetId, saveDeliverable, job, getWorkerBillings, saveExpense, billingType } = this.props;

        const action = { expense: saveExpense, deliverable: saveDeliverable }[billingType];
        const dateField = billingType === 'expense' ? 'expense_date' : 'date';

        action &&
            action(
                {
                    id: values.id,
                    amount: values.amount,
                    [dateField]: dateToFloatingString(values.date, 'YYYY-MM-DD'),
                    description: values.description,
                    timesheet_id: timesheetId,
                    project_id: values.project_id,
                    job_id: job.id,
                    currency: values.currency || job.currency
                },
                () => getWorkerBillings(timesheetId)
            );
    }

    removeBilling(billingId) {
        const { timesheetId, removeDeliverable, removeExpense, getWorkerBillings, billingType } = this.props;
        const action = { expense: removeExpense, deliverable: removeDeliverable }[billingType];
        action && action(billingId, () => getWorkerBillings(timesheetId));
    }

    sortByExpenseDate(a, b) {
        const aDate = a.date || a.expense_date;
        const bDate = b.date || b.expense_date;
        return aDate < bDate ? -1 : aDate > bDate ? 1 : 0;
    }

    expenseProject(d) {
        const { projectsOptions } = this.props;
        const projectOption = projectsOptions.find(option => option.value === d.project_id);
        return projectOption ? projectOption.label : 'n/a';
    }

    getColumnDefinition() {
        const { timesheetId, projectId, job, isPreview, billingType, projectsOptions, projects, noAdd } = this.props;

        const columns = [
            {
                label: <FormattedMessage {...messages.date} />,
                valueMap: d => <div className="full-height-cell ellipsis">{dateToFloatingString(d.date || d.expense_date, 'MMM D')}</div>,
                size: 'col-sm-3 col-md-2 col-xs-7',
                sort: this.sortByExpenseDate
            },
            {
                label: <FormattedMessage {...messages.project} />,
                valueMap: d => {
                    return <div className="full-height-cell ellipsis">{this.expenseProject(d)}</div>;
                },
                size: isPreview ? 'col-md-2 hidden-sm hidden-xs' : 'col-sm-2 hidden-xs',
                sort: (a, b) => this.expenseProject(a).localeCompare(this.expenseProject(b))
            },
            {
                label: <FormattedMessage {...messages.description} />,
                valueMap: d => {
                    return <div className="full-height-cell ellipsis">{d.description}</div>;
                },
                size: isPreview ? 'col-sm-6 col-md-4 hidden-xs' : 'col-sm-3 hidden-xs',
                sort: (a, b) => (a.description || '').localeCompare(b.description || '')
            },
            {
                label: <FormattedMessage {...messages.amount} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis">
                        {getCurrencySymbol(d.currency)} {d.amount.toFixed(2)}
                    </div>
                ),
                size: 'col-sm-3 col-md-3 col-xs-5',
                sort: (a, b) => (a.amount || 0) - (b.amount || 0)
            }
        ];
        const showAdd = !noAdd && !isPreview;

        if (showAdd) {
            columns.push({
                valueMap: d => (
                    <AddBilling
                        timesheetId={timesheetId}
                        projectId={projectId}
                        job={job}
                        onSubmit={this.saveBilling}
                        initialValues={d}
                        onRemove={this.removeBilling}
                        billingType={billingType}
                        projectsOptions={projectsOptions}
                        projects={projects}
                    />
                ),
                size: 'col-xs-2'
            });
        }

        return columns;
    }

    render() {
        const { timesheetId, projects, projectsOptions, billings, job, isPreview, billingType, noAdd } = this.props;

        const showAdd = !noAdd && !isPreview;
        if (!billings || (!showAdd && !billings.length)) {
            return null;
        }
        const title = { expense: messages.expenses, deliverable: messages.deliverables }[billingType] || messages.emptyMessage;
        return (
            <div>
                <div className="deliverables-title">
                    <span className="deliverables-title-label">
                        <FormattedMessage {...title} />
                    </span>
                    {showAdd && (
                        <AddBilling
                            timesheetId={timesheetId}
                            projects={projects}
                            projectsOptions={projectsOptions}
                            job={job}
                            onSubmit={this.saveBilling}
                            billingType={billingType}
                        />
                    )}
                </div>
                {!!billings.length && <Table data={billings} columns={this.getColumnDefinition()} keyExtractor="id" defaultSortColumn={0} />}
            </div>
        );
    }
}

BillingList.defaultProps = {
    noAdd: false
};
BillingList.propTypes = {
    timesheetId: PropTypes.string,
    projects: PropTypes.array,
    projectsOptions: PropTypes.array,
    job: PropTypes.object,
    billings: PropTypes.array,
    billingType: PropTypes.string,
    noAdd: PropTypes.bool
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            saveDeliverable,
            getWorkerBillings,
            removeDeliverable,
            saveExpense,
            removeExpense
        },
        dispatch
    );

BillingList = connect(null, mapDispatchToProps)(BillingList);
export default BillingList;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/billings/index.jsx